import { render, staticRenderFns } from "./UserGroupForm.vue?vue&type=template&id=6df43c51&scoped=true"
import script from "./UserGroupForm.vue?vue&type=script&lang=js"
export * from "./UserGroupForm.vue?vue&type=script&lang=js"
import style0 from "./UserGroupForm.vue?vue&type=style&index=0&id=6df43c51&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df43c51",
  null
  
)

export default component.exports